import { render, staticRenderFns } from "./CreateCustomFieldModal.vue?vue&type=template&id=41cba654&scoped=true"
import script from "./CreateCustomFieldModal.vue?vue&type=script&lang=ts"
export * from "./CreateCustomFieldModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateCustomFieldModal.vue?vue&type=style&index=0&id=41cba654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cba654",
  null
  
)

export default component.exports